import React from "react";

import { Typography } from "@mui/material";
const Links = (props) => {
  return (
    <>
      <Typography
        marginTop={2}
        marginBottom={1}
        sx={{
          fontWeight: "300",
          color: "grey.main",
          verticalAlign: "Top",
          letterSpacing: "0.5%",
          cursor: "pointer",
          textAlign: { md: "start", xs: "center" },
        }}
      >
        {props.data}
      </Typography>
    </>
  );
};

export default Links;
